
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apply/c/[inviteCode]",
      function () {
        return require("private-next-pages/apply/c/[inviteCode].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apply/c/[inviteCode]"])
      });
    }
  